var $=jQuery;

function checkScroll() {
    const header = document.querySelector('sticky-header');
    if (!header) return;
    if (window.scrollY > 0) {
        header.classList.add('scrolled');
    } else {
        header.classList.remove('scrolled');
    }
}

window.addEventListener('load', checkScroll);
window.addEventListener('scroll', checkScroll);

$(document).ready(function () {
    function slider_mobile() {
    if($(window).width() <= 949){
      $(".icons_page.icon-text-section .page-width.icon-text-wrapper").flickity({
          pageDots: false,
          freeScroll: false,
          wrapAround: true,
          prevNextButtons: true,
          autoPlay: 7000,
          groupCells: false,
          cellAlign: 'left',
      });
      $("section.icons_footer.icon-text-section .page-width.icon-text-wrapper").flickity({
          pageDots: false,
          freeScroll: false,
          wrapAround: true,
          prevNextButtons: true,
          autoPlay: 7000,
          groupCells: false,
          cellAlign: 'left',
      });
    }
  }
  $(document).ready(slider_mobile);
  $(window).on('resize', function() {
    slider_mobile();
  });
    $('.header__inline-menu .mega-menu__content ul.mega-menu__list>li>a.has_sub').click(function (e) { 
      e.preventDefault();
      $('.header__inline-menu .mega-menu__content ul.mega-menu__list>li>a.has_sub').removeClass('showing');
      $(this).addClass('showing');
    });
    $('#verticalTitle').click(function() {
        $(this).toggleClass('active');
        $('.facets__form-vertical').toggleClass('facets__form-vertical_show');
    });
    $('form#FacetFiltersForm button.button.button--primary').click(function() {
        $('.facets__form-vertical').toggleClass('facets__form-vertical_show');
    });

    $('.footer-block.has-dropdown .footer-block__heading').click(function (e) { 
      e.preventDefault();
      $(this).toggleClass('active');
    });
    $('.notification-close').click(function (e) { 
        e.preventDefault();
        $('.notification-bar').slideUp();
    });
    function setEqualHeight() {
      var maxHeight = 0;
      $('.collection .card__heading').css('height', 'auto');
  
      $('.collection .card__heading').each(function() {
          var currentHeight = $(this).outerHeight();
          if (currentHeight > maxHeight) {
              maxHeight = currentHeight;
          }
      });
  
      $('.collection .card__heading').each(function() {
          $(this).css('height', maxHeight + 'px');
      });
    }

    $(document).ready(function() {
        setEqualHeight();
    });
    
    $(window).on('resize', function() {
        setEqualHeight();
    });
    $('.product-single__gallery').flickity({
        imagesLoaded: true,
        groupCells: false,
        dragThreshold: 5,
        cellAlign: 'center',
        wrapAround: true,
        prevNextButtons: true,
        percentPosition: true, 
        pageDots: false,
        rightToLeft: false,
        autoPlay: false,
        sync: '.product-single__thumbnails'
    }); 
  
    $('.product-single__gallery').on('change.flickity', function(event, index) {
        var $thumbnails = $('.product-single__thumbnails li');
        $thumbnails.removeClass('active');  // Remove 'active' class from all thumbnails
        $thumbnails.eq(index).addClass('active');  // Add 'active' class to the current thumbnail
    });
    $('.product-single__thumbnails li').first().addClass('active');
  
    // Thumbnail click event to change the gallery image
    $('.product-single__thumbnails li').on('click', function() {
        var index = $(this).index();
        $('.product-single__gallery').flickity('select', index);  // Select the corresponding image in the gallery
    });
    ///// Tab Faq
    $(document).on('click','.acctab_title', function(e){
        if($(window).width() >= 768){
            $('.acctab_title').removeClass('active-accor');
            $(this).addClass('active-accor');
            $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
            $($(this).attr('data-act-title')).addClass('activemain-tab').show();
        }else{
        $('.acctab_title').removeClass('active-accor');
            $(this).addClass('active-accor');
            $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
            $($(this).attr('data-act-title')).addClass('activemain-tab').show();
            // $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
            $('.acc_tab-inner .acc-tab-content').addClass('tab-content-show').show();
            $($(this).attr('data-act-title')).addClass('activemain-tab').show();
        }
    });
    $(document).on('click','.acc_tab-inner .acc-tab-content .back__arrow', function(e){
        $('.acc_tab-inner .acc-tab-content').removeClass('tab-content-show').show();
    });
    $('.acc-head').on('click', function() {
        if($(this).hasClass('active')) {
            $(this).siblings('.acc-content').slideUp();
            $(this).removeClass('active');
        }
        else {
            $('.acc-content').slideUp();
            $('.acc-head').removeClass('active');
            $(this).siblings('.acc-content').slideToggle();
            $(this).toggleClass('active');
        }
    });
    //Slider collection list
    $('.collection-list-wrapper .collection-list').flickity({ 
        imagesLoaded: true,
        groupCells: false,
        dragThreshold: 5,
        cellAlign: 'left',
        wrapAround: true,
        prevNextButtons: true,
        percentPosition: true, 
        pageDots: false,
        rightToLeft: false,
        autoPlay: false,
    });
    //End Slider collection list
    /*** LOAD MORE **/
   /*** LOAD MORE **/
    $(document).ready(function () {
      const COLLECTION_STATE_PREFIX = 'collection-load-more-state:';
      const COLLECTION_STATE_TTL = 1000 * 60 * 60 * 6; // 6 hours

      if ('scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
      }

      function getCollectionStateKey() {
        const params = new URLSearchParams(window.location.search);
        params.delete('page');

        const queryString = params.toString();

        return COLLECTION_STATE_PREFIX + window.location.pathname + (queryString ? '?' + queryString : '');
      }

      function saveCollectionState(scrollY) {
        const $grid = $('ul#product-grid');

        if (!$grid.length) return;

        const $buttonWrapper = $('[data-pagination-link]').first().closest('.show_more_btn');

        const state = {
          gridHtml: $grid.html(),
          buttonHtml: $buttonWrapper.length ? $buttonWrapper.prop('outerHTML') : '',
          scrollY: typeof scrollY === 'number' ? scrollY : window.pageYOffset,
          savedAt: Date.now()
        };

        try {
          sessionStorage.setItem(getCollectionStateKey(), JSON.stringify(state));
        } catch (error) {
          console.warn('Could not save collection state.', error);
        }
      }

      function restoreCollectionState() {
        const $grid = $('ul#product-grid');

        if (!$grid.length) return;

        const rawState = sessionStorage.getItem(getCollectionStateKey());

        if (!rawState) return;

        let state;

        try {
          state = JSON.parse(rawState);
        } catch (error) {
          sessionStorage.removeItem(getCollectionStateKey());
          return;
        }

        if (!state || !state.gridHtml || Date.now() - state.savedAt > COLLECTION_STATE_TTL) {
          sessionStorage.removeItem(getCollectionStateKey());
          return;
        }

        $grid.html(state.gridHtml);

        $('.show_more_btn').remove();

        if (state.buttonHtml) {
          $grid.after(state.buttonHtml);
        }

        const scrollY = state.scrollY || 0;

        setTimeout(function () {
          window.scrollTo(0, scrollY);
        }, 100);

        setTimeout(function () {
          window.scrollTo(0, scrollY);
        }, 500);

        setTimeout(function () {
          window.scrollTo(0, scrollY);
        }, 1000);
      }

      restoreCollectionState();


      function refreshRFQApp($newItems) {
      const $grid = $('#product-grid');
      const section = $grid.closest('.shopify-section')[0];

      // Notify theme scripts and third-party apps that the section has been updated
      if (section) {
        section.dispatchEvent(
          new CustomEvent('shopify:section:load', {
            bubbles: true,
            detail: {
              sectionId: section.id.replace('shopify-section-', '')
            }
          })
        );
      }

      // Dispatch a custom event after new collection products are loaded
      document.dispatchEvent(
        new CustomEvent('collection:updated', {
          detail: {
            container: $grid[0],
            newItems: $newItems.toArray()
          }
        })
      );

      // Stop if the RFQ app is not available
      if (!window.GRFQApp) return;

      // Try the available RFQ app initialization methods
      if (typeof window.GRFQApp.refresh === 'function') {
        window.GRFQApp.refresh($grid[0]);
        return;
      }

      if (typeof window.GRFQApp.initCollection === 'function') {
        window.GRFQApp.initCollection($grid[0]);
        return;
      }

      if (typeof window.GRFQApp.initCollectionButtons === 'function') {
        window.GRFQApp.initCollectionButtons($grid[0]);
        return;
      }

      if (typeof window.GRFQApp.init === 'function') {
        window.GRFQApp.init();
      }
    }

    function scheduleRFQRefresh($newItems) {
      // Retry initialization because the RFQ app script may load asynchronously
      [0, 300, 1000].forEach(function (delay) {
        setTimeout(function () {
          // Only refresh when the newly loaded products do not have RFQ buttons yet
          if (!$newItems.find('.rfq-collection-btn').length) {
            refreshRFQApp($newItems);
          }
        }, delay);
      });
    }

    $(document).on('click', '[data-pagination-link]', function (e) {
      e.preventDefault();

      const $button = $(this);
      const nextUrl = $button.attr('href');

      if (!nextUrl || $button.hasClass('is-loading')) return;

      const originalText = $button.text();

      // Set the load-more button to its loading state
      $button
        .addClass('is-loading')
        .text('Laden...')
        .prop('disabled', true);

      $.get(nextUrl)
        .done(function (response) {
          const $tempDiv = $('<div>').html(response);

          // Get the individual product items from the next page
          const $newItems = $tempDiv.find('ul#product-grid > li');

          // Get the next load-more button wrapper
          const $newPagination = $tempDiv
            .find('[data-pagination-link]')
            .first()
            .closest('.show_more_btn');

          if ($newItems.length) {
            // Append the newly loaded products to the current product grid
            $('ul#product-grid').append($newItems);

            // Reinitialize the RFQ app for the newly added products
            scheduleRFQRefresh($newItems);
          }

          // Remove the current load-more button
          $button.closest('.show_more_btn').remove();

          // Add the next load-more button when another page is available
          if ($newPagination.length) {
            $('ul#product-grid').after($newPagination);
          }
            setEqualHeight();
          // Save the current collection state and scroll position
        //  saveCollectionState(window.pageYOffset);
        })
        .fail(function () {
          console.error('Error loading more products.');

          // Restore the button when the request fails
          $button
            .removeClass('is-loading')
            .text(originalText || 'Try again')
            .prop('disabled', false);
        });
    });


        $(document).on('click', '#product-grid a[href*="/products/"]', function () {
          saveCollectionState(window.pageYOffset);
        });

        $('.has_dropdown p.footer-block__heading.inline-richtext').click(function (e) {
          e.preventDefault();
          $(this).toggleClass('active');
        });
      });
});

/**** CUSTOM  PRICE ***/

//price custom
class PriceRange1 extends HTMLElement {
    connectedCallback() {
      this.rangeLowerBound = this.querySelector(".price-range__range-group input:first-child");
      this.rangeHigherBound = this.querySelector(".price-range__range-group input:last-child");
      this.textInputLowerBound = this.querySelector(".price-range__input:first-child input");
      this.textInputHigherBound = this.querySelector(".price-range__input:last-child input");
  
      // Event listeners for text input focus and change
      this.textInputLowerBound.addEventListener("focus", () => this.textInputLowerBound.select());
      this.textInputHigherBound.addEventListener("focus", () => this.textInputHigherBound.select());
  
      this.textInputLowerBound.addEventListener("change", (event) => {
        const newValue = Math.max(Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1), event.target.min);
        event.target.value = newValue;
        this.rangeLowerBound.value = newValue;
        this.updateRangeStyles();
      });
  
      this.textInputHigherBound.addEventListener("change", (event) => {
        const newValue = Math.min(Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1), event.target.max);
        event.target.value = newValue;
        this.rangeHigherBound.value = newValue;
        this.updateRangeStyles();
      });
  
      // Event listeners for range slider change and input
      this.rangeLowerBound.addEventListener("change", (event) => {
        this.textInputLowerBound.value = event.target.value;
        this.textInputLowerBound.dispatchEvent(new Event("change", { bubbles: true }));
      });
  
      this.rangeHigherBound.addEventListener("change", (event) => {
        this.textInputHigherBound.value = event.target.value;
        this.textInputHigherBound.dispatchEvent(new Event("change", { bubbles: true }));
      });
  
      this.rangeLowerBound.addEventListener("input", (event) => {
        this.dispatchEvent(new CustomEvent("collection:abort-loading", { bubbles: true }));
        event.target.value = Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1);
        this.textInputLowerBound.value = event.target.value;
        this.updateRangeStyles();
      });
  
      this.rangeHigherBound.addEventListener("input", (event) => {
        this.dispatchEvent(new CustomEvent("collection:abort-loading", { bubbles: true }));
        event.target.value = Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1);
        this.textInputHigherBound.value = event.target.value;
        this.updateRangeStyles();
      });
    }
  
    updateRangeStyles() {
      this.rangeLowerBound.parentElement.style.setProperty("--range-min", `${(parseInt(this.rangeLowerBound.value) / parseInt(this.rangeLowerBound.max)) * 100}%`);
      this.rangeHigherBound.parentElement.style.setProperty("--range-max", `${(parseInt(this.rangeHigherBound.value) / parseInt(this.rangeHigherBound.max)) * 100}%`);
    }
}
window.customElements.define("price-range1", PriceRange1);


    document.addEventListener('DOMContentLoaded', function() {
      const params = new URLSearchParams(window.location.search);

      if (params.get('open_cart') === '2') {
        const url = new URL(window.location.href);
        url.searchParams.delete('open_cart');

        window.history.replaceState(
          {},
          document.title,
          url.pathname + url.search + url.hash
        );

        setTimeout(function() {
          const cartIcon = document.querySelector('#cart-icon-bubble');

          if (cartIcon) {
            cartIcon.click();
          }
        }, 400);
      }
    });
    

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-related-section .quick-add.no-js-hidden .quick-add__submit:disabled').forEach(function (button) {
    button.disabled = false;
    button.classList.add('quick-add-quote');

    button.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();

      window.location.href = '/pages/request-for-quote';
    });
  });
});